import Btn, { BtnModifier } from 'components/btn';
import Header, { HeaderModifier } from 'components/header';
import PlusIcon from 'assets/icons/plus.svg';
import { useTranslation } from 'react-i18next';
import BalanceCheckLeftTableWithReactQueryProvider, { BalanceCheckLeftTableDef } from 'components/table/balancecheck/balanceCheckLeftTable';
import OverviewRightTableWithReactQueryProvider, { OverviewRightTableDef } from 'components/table/overviewRightTable';
import OverviewCsvTableWithReactQueryProvider, { OverviewCsvTableDef } from 'components/table/overviewCsvTable';
import { LocationHistoryMismatch } from 'components/table/balanceTable';
import BalanceCheckTableFilters from 'components/table/filters/balanceCheckTableFilters';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TableDataRes } from 'components/table/base/tableBaseApi';
import { TooltipAlignEnum } from 'components/tooltip';
export interface OverviewSideTableProps {
  data: boolean;//use cached data for left table

  filters: string;
  setFilters: (value: string) => void;

  globalFilter: string;

  currentMismatch: boolean | undefined;
  setCurrentMismatch: (value: boolean | undefined) => void;

  userCurrencyMismatch: boolean | undefined;
  setUserCurrencyMismatch: (value: boolean | undefined) => void;

  showSpinners: boolean;
  setShowSpinners: (value: boolean) => void;

  isFetching: boolean;
  setIsFetching: (value: boolean) => void;

  onRightTableLoaded: (value: TableDataRes<OverviewRightTableDef, any>) => void;
  onLeftTableLoaded: (value: TableDataRes<OverviewLeftTableDef, any>) => void;

  goToDetailSideEffect: () => void;
}

function OverviewSideComponent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const [filters, setFilters] = useState('');
  const [filtersRight, setFiltersRight] = useState('');//should only refresh for search

  //for table local search
  const [globalFilter, setGlobalFilter] = useState('');


  const [warningsUpdate, setWarningsUpdate] = useState<boolean>(false);
  const [showReportedBalances, setShowReportedBalances] = useState<boolean>(false);
  const [currentMismatch, setCurrentMismatch] = useState<boolean | undefined>(undefined);
  const [userCurrencyMismatch, setUserCurrencyMismatch] = useState<boolean | undefined>(undefined);
  const [showSpinners, setShowSpinners] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  //cache on detail navigation
  const [rightData, setRightData] = useState<TableDataRes<OverviewRightTableDef, any> | undefined>(undefined);
  const [rightDataCsv, setRightDataCsv] = useState<TableDataRes<OverviewCsvTableDef, any> | undefined>(undefined);
  const saveRightDataToLocalStorage = () : void => {
    if (rightData) {
      try {
        window.localStorage.setItem('overview_right_table', JSON.stringify(rightData));
      } catch {}
    }
    if (rightDataCsv) {
      try {
        window.localStorage.setItem('overview_csv_table', JSON.stringify(rightDataCsv));
      } catch {}
    }
  };

  return (
    <>
      <div className="ct_padding">
        <div className="ct_section _oldView">
          <div className="ct_section-inner">
            <div className="ct_section-main">
              <div className="ct_overviewHeader">
                <div className="ct_overviewHeader-main">
                  <Header
                    headline={t('Import overview', { ns: 'overview' })}
                    desc={t('This report provides a comprehensive overview of your current balances categorized by exchange and wallet.', { ns: 'overview' })}
                    modifiers={[HeaderModifier.OLD, HeaderModifier.OLD_MARGIN]}
                  />
                </div>
                             <div className="ct_overviewHeader-aside">
                  <Btn
                    onClick={() => navigate('/import')}
                    icon={<PlusIcon />}
                    type="primary"
                    text={t('Add Import', { ns: 'overview' })}
                    modifier={[BtnModifier.OLD, BtnModifier.OVERVIEW_SIDE]}
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="ct_section _oldView">
          <div className="ct_section-inner">
            <div className="ct_section-main">
              <div className="ct_overviewHeader _side">
                <div className="ct_overviewHeader-mainSide">
                <BalanceCheckTableFilters
                    useLocalSearch={true}
                    ignoreSmallMismatchesProp={false}
                    ignoreUserCurrencyMismatchesProp={
                      (location.state as LocationHistoryMismatch !== undefined)
                      && (location.state as LocationHistoryMismatch !== null)
                      && ((location.state as LocationHistoryMismatch).dataCurrency !== undefined)
                      && ((location.state as LocationHistoryMismatch).dataCurrency !== null)
                        ? (location.state as LocationHistoryMismatch).dataCurrency! : true
                    }
                    onSmallMismatchUpdate={() => {}}
                    onUserCurrencyMismatchUpdate={(value: boolean) => setUserCurrencyMismatch(value)}
                    onWarningsUpdate={(value: boolean) => {
                      setWarningsUpdate(value);
                    }}
                    onShowReportedBalanceUpdate={(value: boolean) => {
                      setShowReportedBalances(value);
                    }}
                    showWarningsProp={warningsUpdate}
                    showReportedBalancesProp={showReportedBalances}
                    onFitlerCB={(value: string) => {
                        const rightValue = value.split('&').filter(e => e.startsWith('filter[ignoreSmallMismatches]='));
                        if (rightValue.length > 0) {
                          setFiltersRight('filter[noCache]=0&'+rightValue[0]);
                        } else {
                          setFiltersRight('filter[noCache]=1');//first load
                        }
                        setFilters(value);
                      }
                    }
                    onGlobalFilterUpdate={(value: string) => {
                        setGlobalFilter(value);
                      }
                    }
                    disabled={showSpinners}
                    leftAlignedSearch={false}
                    tooltipAlignment={TooltipAlignEnum.LEFT}
                  />
                  <BalanceCheckLeftTableWithReactQueryProvider
                  data={(location.state as LocationHistoryMismatch !== undefined)
                    && (location.state as LocationHistoryMismatch !== null)
                    && ((location.state as LocationHistoryMismatch).tableChanged !== undefined)
                    && ((location.state as LocationHistoryMismatch).tableChanged !== null)
                      ? (location.state as LocationHistoryMismatch).tableChanged! : false}
                  filters={filters} 
                  globalFilter={globalFilter}
                  setFilters={(value) => setFilters(value)}
                  warningsUpdate={warningsUpdate} 
                  setWarningsUpdate={ value => setWarningsUpdate(value) } 
                  showReportedBalances={ showReportedBalances } 
                  setShowReportedBalances={ value => setShowReportedBalances(value) } 
                  userCurrencyMismatch={ userCurrencyMismatch }
                  setUserCurrencyMismatch={ value => setUserCurrencyMismatch(value) }
                  showSpinners={ showSpinners } 
                  setShowSpinners={value => setShowSpinners(value)}
                  isFetching={ isFetching } 
                  setIsFetching={value => setIsFetching(value)}
                  onRightTableLoaded={() => {}} 
                  onLeftTableLoaded={() => {}}
                  goToDetailSideEffect={() => {
                    saveRightDataToLocalStorage();
                  }}
                  routeName={'overview'}
                  />
                </div>
                <div className="ct_overviewHeader-asideSide">
                  <OverviewRightTableWithReactQueryProvider
                  data={(location.state as LocationHistoryMismatch !== undefined)
                    && (location.state as LocationHistoryMismatch !== null)
                    && ((location.state as LocationHistoryMismatch).tableChanged !== undefined)
                    && ((location.state as LocationHistoryMismatch).tableChanged !== null)
                      ? (location.state as LocationHistoryMismatch).tableChanged! : false}
                  filters={filtersRight}
                  globalFilter={globalFilter}
                  setFilters={(value) => setFiltersRight(value)}
                  currentMismatch={currentMismatch}
                  setCurrentMismatch={ value => setCurrentMismatch(value) }
                  userCurrencyMismatch={ userCurrencyMismatch }
                  setUserCurrencyMismatch={ value => setUserCurrencyMismatch(value) }
                  showSpinners={ showSpinners }
                  setShowSpinners={() => {}}
                  isFetching={ isFetching }
                  setIsFetching={() => {}}
                  onRightTableLoaded={(data) => {
                    setRightData(data);
                  }}
                  onLeftTableLoaded={() => {}}
                  goToDetailSideEffect={() => {}}
                  />
                  <div className='ct_overviewHeaderSpacing' />
                  <OverviewCsvTableWithReactQueryProvider
                  data={(location.state as LocationHistoryMismatch !== undefined)
                    && (location.state as LocationHistoryMismatch !== null)
                    && ((location.state as LocationHistoryMismatch).tableChanged !== undefined)
                    && ((location.state as LocationHistoryMismatch).tableChanged !== null)
                      ? (location.state as LocationHistoryMismatch).tableChanged! : false}
                  filters={filtersRight}
                  globalFilter={globalFilter}
                  setFilters={(value) => setFiltersRight(value)}
                  currentMismatch={currentMismatch}
                  setCurrentMismatch={ value => setCurrentMismatch(value) }
                  userCurrencyMismatch={ userCurrencyMismatch }
                  setUserCurrencyMismatch={ value => setUserCurrencyMismatch(value) }
                  showSpinners={ showSpinners }
                  setShowSpinners={() => {}}
                  isFetching={ isFetching }
                  setIsFetching={() => {}}
                  onRightTableLoaded={(data) => {
                    setRightDataCsv(data);
                  }}
                  onLeftTableLoaded={() => {}}
                  goToDetailSideEffect={() => {}}
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default OverviewSideComponent;
